import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "step-auto" }
const _hoisted_2 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_5 = { class: "d-flex gap-2 align-items-center flex-wrap" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 1,
  class: "fas fa-eye"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-play"
}
const _hoisted_12 = {
  key: 2,
  class: "alert alert-danger py-2 small mt-2 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step.id === 'load-new-ranks--c')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label small fw-bold mb-1" }, [
            _createTextVNode(" ranksConfiguration nueva (JSON) "),
            _createElementVNode("span", { class: "text-muted fw-normal" }, [
              _createTextVNode(" — marca el centinela con "),
              _createElementVNode("code", null, "\"isSentinel\": true")
            ])
          ], -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ranksJson) = $event)),
            class: "form-control form-control-sm font-monospace",
            rows: "6",
            placeholder: _ctx.ranksPlaceholder
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.ranksJson]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step.id === 'remap-rank-refs--c')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label small fw-bold mb-1" }, [
            _createTextVNode(" Mapeo de rangos viejo → nuevo (JSON) "),
            _createElementVNode("span", { class: "text-muted fw-normal" }, " — un ID que el mapeo no cubra se REPORTA, nunca se adivina ")
          ], -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mapJson) = $event)),
            class: "form-control form-control-sm font-monospace",
            rows: "4",
            placeholder: "{ \"OLD-INF\": \"INFLUENCER\", \"OLD-B300\": \"B300\" }"
          }, null, 512), [
            [_vModelText, _ctx.mapJson]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-outline-secondary",
        disabled: _ctx.busy || !_ctx.unlocked || !!_ctx.parseError,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitRun(true)))
      }, [
        (_ctx.runningDry)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7))
          : (_openBlock(), _createElementBlock("i", _hoisted_8)),
        _cache[6] || (_cache[6] = _createTextVNode(" Dry-run ", -1))
      ], 8, _hoisted_6),
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-sm", _ctx.step.id === 'unfreeze--c' ? 'btn-success' : 'btn-danger']),
        disabled: _ctx.busy || !_ctx.unlocked || !!_ctx.parseError,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitRun(false)))
      }, [
        (_ctx.runningRun)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
          : (_openBlock(), _createElementBlock("i", _hoisted_11)),
        _cache[7] || (_cache[7] = _createTextVNode(" Ejecutar ", -1))
      ], 10, _hoisted_9),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted small" }, " El dry-run reporta sin escribir nada, y sin marcar el paso como hecho. Lo que devuelve sale AQUÍ ABAJO (no deja rastro en el run: si no se pinta, no existe). ", -1))
    ]),
    (_ctx.parseError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " JSON inválido: " + _toDisplayString(_ctx.parseError), 1))
      : _createCommentVNode("", true)
  ]))
}